import { addDays, format, getDay, parseISO } from "date-fns";

/** 曜日ラベル（0=日曜〜6=土曜） */
export const DAY_LABELS: Record<number, string> = {
  0: "日",
  1: "月",
  2: "火",
  3: "水",
  4: "木",
  5: "金",
  6: "土",
};

/** フォーム用の曜日オプション（月曜始まり） */
export const DAY_OPTIONS = [
  { value: 1, label: "月" },
  { value: 2, label: "火" },
  { value: 3, label: "水" },
  { value: 4, label: "木" },
  { value: 5, label: "金" },
  { value: 6, label: "土" },
  { value: 0, label: "日" },
] as const;

/**
 * 曜日番号配列を「月・水・金」形式の文字列に変換
 * 月曜始まりでソートする
 */
export function formatDaysOfWeek(days: number[]): string {
  const mondayFirst = [1, 2, 3, 4, 5, 6, 0];
  const sorted = [...days].sort(
    (a, b) => mondayFirst.indexOf(a) - mondayFirst.indexOf(b)
  );
  return sorted.map((d) => DAY_LABELS[d] ?? "?").join("・");
}

interface RepeatSchedule {
  daysOfWeek: number[];
  startDate: string;
  endDate?: string;
}

/**
 * リピート予約の次回予約日を算出（今日から最大7日先まで探索）
 * @returns YYYY-MM-DD形式の日付文字列、該当なしならnull
 */
export function getNextReservationDate(repeat: RepeatSchedule): string | null {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const endDate = repeat.endDate ? parseISO(repeat.endDate) : null;

  for (let i = 0; i < 7; i++) {
    const candidate = addDays(today, i);
    const dayOfWeek = getDay(candidate);

    if (!repeat.daysOfWeek.includes(dayOfWeek)) {
      continue;
    }

    const candidateStr = format(candidate, "yyyy-MM-dd");

    if (candidateStr < repeat.startDate) {
      continue;
    }

    if (endDate && candidate > endDate) {
      continue;
    }

    return candidateStr;
  }

  return null;
}
